
import HomeCertificate from '../Home/HomeCertificate'
export default {
  components: {
    HomeCertificate
  },
  data () {
    return {
      data: {
        title: 'Our Standard',
        info: 'Our main product, Medium Density Fiberboard (MDF) is a wood based panel that is formed by separating logs into wood fibres and then reforming them into panels under heat and pressure. The final product is a panel with a homogenous structure, smooth surfaces and uniform properties. These versatile panels can be sawed, routed, sanded and screwed just like any wood panel or easily surface covered using a variety of process. We have the option of using rubber trees or eucalyptus to make the MDF panels - both are sourced from renewable plantations',
      }
    }
  },
  methods: {
    toPage (url) {
      this.$router.push(url)
    }
  }
}
